import { Container, Box } from '@mui/material';
import React from 'react';
import ClientsScss from './Clients.module.scss';
import clients1 from '../../Common/Image/clients1.png';
import clients2 from '../../Common/Image/clients2.png';
import clients3 from '../../Common/Image/clients3.png';
import clients4 from '../../Common/Image/clients4.png';

function Clients() {
    return (
        <section id={ClientsScss.clients}>
            <Container>
                <Box className={ClientsScss.clients}>
                    <Box className={ClientsScss.clientsItem}>
                        <img src={clients1} alt='clients1'></img>
                    </Box>
                    <Box className={ClientsScss.clientsItem}>
                        <img src={clients2} alt='clients1'></img>
                    </Box>
                    <Box className={ClientsScss.clientsItem}>
                        <img src={clients3} alt='clients1'></img>
                    </Box>
                    <Box className={ClientsScss.clientsItem}>
                        <img src={clients4} alt='clients1'></img>
                    </Box>
                </Box>
            </Container>


        </section>
    )
}

export default Clients;
